import {hydrate} from 'react-dom';
import GameComponent from "./GameComponent";
import {DEFAULT_GAME_DATA} from "./gameData";
const host = window.location.hostname;
if (host.includes('mymoneyrain.com') || host.includes('custom-progressbar.com') || host.includes('local')) {
    let data = localStorage.getItem("dataLilRooster");
    if (data) {
        data = JSON.parse(data);
      //  data = DEFAULT_GAME_DATA;
    } else {
        data = DEFAULT_GAME_DATA;
        localStorage.setItem("dataLilRooster", JSON.stringify(DEFAULT_GAME_DATA));
    }

    const container = document.querySelector("#game");
    hydrate(<GameComponent data={data}/>, container, function (re) {
    });
}
